module.exports = __webpack_public_path__ + "img/originality-light.1b37b2e1.svg";